import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useState } from 'react';
import { CnMessage, CnInput, Form, Grid, CnCard, CnAsyncSelect, CnButton, CnFilterItem, } from '@alife/cn-ui';
import { getCnVasPayerInfo, saveCnVasPayerInfo } from '../../api';
const { Row, Col } = Grid;
/**
 *  交货单--增值服务
 */
export default function CpPayment(props) {
    const { asnCode, handleSearch, values, remarks, setValues, setRemarks, changeBlg, selfVasDetailList, } = props;
    const isBlg = changeBlg == '2';
    const [loading, setLoading] = useState(false);
    const [cpList, setCpList] = useState([]);
    const params = {
        asnCode,
        payerType: values,
        remark: remarks,
    };
    // cp - 付款方信息
    /** 获取付款方信息 */
    const getCpList = useCallback(() => {
        getCnVasPayerInfo({
            asnCode,
        }).then((res) => {
            setCpList((res?.data || []).map((item) => ({
                label: item.payerDesc,
                value: item.payerNum,
            })));
        });
    }, [asnCode]);
    // /** 保存付款方信息 */
    const handleSave = () => {
        setLoading(true);
        saveCnVasPayerInfo(params)
            .then(() => {
            CnMessage.success($i18n.get({ id: 'SavedSuccessfully', dm: '保存成功' }));
            if (params.payerType != null && params.remark != '') {
                handleSearch();
            }
        })
            .catch(() => {
            CnMessage.error($i18n.get({
                id: 'PleaseCompleteTheLoadingAndUnloa_1412167145',
                dm: '请填写完装卸付款方信息',
            }));
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const valuesFn = () => {
        setValues(null);
        return null;
    };
    const remarksFn = () => {
        setRemarks('');
        return '';
    };
    useEffect(() => {
        getCpList();
    }, [getCpList]);
    return (React.createElement(CnCard, { title: $i18n.get({
            id: '4LoadingAndUnloadingPayers',
            dm: '4.装卸付款方',
        }), action: React.createElement(CnButton, { loading: loading, className: 'right-btn', type: 'secondary', onClick: handleSave }, $i18n.get({ id: 'Save', dm: '保存' })) },
        React.createElement(Form, null,
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 12 },
                    React.createElement(CnFilterItem, { label: $i18n.get({ id: 'Payer', dm: '付款方' }), required: !isBlg, name: 'payerType', requiredMessage: $i18n.get({
                            id: 'PayerCannotBeEmpty',
                            dm: '付款方不能为空',
                        }) },
                        React.createElement(CnAsyncSelect, { showSearch: true, hasClear: true, value: selfVasDetailList.some((item) => {
                                return item.selfVasPayStatus !== '-1';
                            })
                                ? values
                                : valuesFn(), dataSource: cpList, style: { width: '100%' }, onChange: (value) => {
                                if (value) {
                                    setValues(value);
                                }
                                else {
                                    setValues(null);
                                }
                            } }))),
                React.createElement(Col, { span: 12 },
                    React.createElement(CnFilterItem, { required: !isBlg, requiredMessage: $i18n.get({
                            id: 'PayerNoteCannotBeEmpty',
                            dm: '付款方备注不能为空',
                        }), label: $i18n.get({
                            id: 'RemarksToPayerFormatNamePhone',
                            dm: '付款方备注（格式：名称/电话）',
                        }), name: 'remark' },
                        React.createElement(CnInput, { maxLength: 30, trim: true, hasClear: true, placeholder: $i18n.get({
                                id: 'gxms-pc_Enter.CNTM',
                                dm: '请输入',
                            }), value: selfVasDetailList.some((item) => {
                                return item.selfVasPayStatus !== '-1';
                            })
                                ? remarks
                                : remarksFn(), onChange: (remark) => {
                                if (remark) {
                                    setRemarks(remark);
                                }
                                else {
                                    setRemarks('');
                                }
                            } })))))));
}
